import { Styles, generateClasses } from 'netline-ui';

export const preloginViewClasses = generateClasses('PreloginView', ['root'] as const);

const styles: Styles = () => ({
  [`&.${preloginViewClasses.root}`]: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
});

export default styles;
